
import { Component, defineComponent } from 'vue';
import { _Util } from "../MyUtil";
import { _ServerApi } from "../serverAPI";
import * as _ from "lodash";

export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
      "email": "",
      "auth_num": "",
      "is_email_send": false,
      "is_email_check" : false,
      "text_password1" : "",
      "text_password2" : "",
    }
  },
  components: {
  },
  methods: {
    click_ok() {
      return "";
    },
    openPop(title: any, msg: string) {
      if (!_.isString(title)) {
        title = "안내";
      }
      var root: any = this.$root;
      root.openPop(title, msg);
    },
    async send_email_auth_num() {
      try {
        const util = _Util.getInstance();
        const email = this.email;
        var _api = _ServerApi.getInstance();
        if (email == "") {
          this.openPop("안내", "이메일을 입력하세요.");
          return;
        }
        if (!util.isEamilString(email)) {
          this.openPop("안내", "이메일을 정확히 입력하세요.");
          return;
        }
        await util.setLoading({isLoading:true,"vue_ele" : this.$root});
        var result = await _api.postJson("/api/emailAuth", { "email": email });
        await util.setLoading({isLoading:false,"vue_ele" : this.$root});
        if (result.isError) {
          this.openPop("안내",result.msg);
          return;
        }
        this.is_email_send = true;
        this.openPop("안내", "메일에서 인증번호를 확인해주세요");

      }
      catch (e) {
        console.error(e);
      }
    },
    async checkEmail() {
      try {
        const email = this.email;
        const auth_num = this.auth_num;
        if(!this.is_email_send){
          this.openPop("오류","인증번호 발송 후 이용하세요");
          return;
        }
        if(auth_num.length < 6){
          this.openPop("오류","이메일에서 받은 인증번호를 정확히 입력하세요");
          return;
        }
        
        var _api = _ServerApi.getInstance();
        const util = _Util.getInstance();
        await util.setLoading({isLoading:true,"vue_ele" : this.$root});
        var result = await _api.postJson("/api/emailAuthCheck", { "email": email, "auth_num": auth_num, });
        await util.setLoading({isLoading:false,"vue_ele" : this.$root});
        if (result.isError) {
          this.openPop("오류",result.msg);
          return;
        }
        this.is_email_check = true;
        this.openPop("안내", "인증번호를 확인했습니다.");
      }
      catch (e) {
        console.error(e);
      }

    },

    async joinMember(){

      try {
        var util = _Util.getInstance();
        if (!this.is_email_send) {
          this.openPop("안내", "이메일 인증번호를 받으세요");
          return;
        }
        if (!this.is_email_check) {
          this.openPop("안내", "이메일 인증번호를 확인하세요.");
          return;
        }
        const is_passwd = util.isPasswdString(this.text_password1);
        if (!is_passwd) {
          this.openPop("안내", "최소8자 영문 숫자 특수문자가 필요합니다.");
          return;
        }
        if (this.text_password1 != this.text_password2) {
          this.openPop("안내", "비밀번호를 입력과 확인이 다릅니다.");
          return;
        }
        const _api = _ServerApi.getInstance();
        await util.setLoading({isLoading:true,"vue_ele" : this.$root});

        const result = await _api.postJson("/api/joinMember", {
          "email": this.email,
          "auth_num": this.auth_num,
          "password": this.text_password1,
        });
        await util.setLoading({isLoading:false,"vue_ele" : this.$root});

        if (result.isError){
          this.openPop("오류",result.msg);
          return;
        }
        this.$router.replace("/JoinEnd");


      }
      catch (e) {
        console.error(e);
      }

      

    }
  },
});
